<div class="login-page">
  <!-- Session check runs before the form paints, so an already-signed-in user
       never sees a login form flash before being routed into the app. -->
  <div *ngIf="isHydrating" class="login-hydrating" role="status" aria-live="polite">
    <span class="login-spinner" aria-hidden="true"></span>
    <span class="login-hydrating-text">Checking your session...</span>
  </div>

  <div *ngIf="!isHydrating" class="login-card">
    <img
      class="login-logo"
      src="assets/images/logo-1.svg"
      alt="Mobiltex CorInsights"
      width="180"
      height="46"
    />

    <!-- ───────────── Step 1: email entry ───────────── -->
    <ng-container *ngIf="step === LoginStep.EmailEntry">
      <h1 class="login-heading">Sign in to your account</h1>
      <p class="login-subheading">Enter your email to continue.</p>

      <form [formGroup]="emailForm" (ngSubmit)="onEmailSubmit()" novalidate>
        <div class="login-field">
          <input
            id="login-email"
            class="login-input"
            [class.login-input-error]="showEmailValidationError || emailNotFound"
            type="email"
            formControlName="email"
            placeholder="name@company.com"
            aria-label="Email"
            autocomplete="email"
            inputmode="email"
            spellcheck="false"
            autocapitalize="off"
            required
            [attr.aria-invalid]="showEmailValidationError || emailNotFound"
            [attr.aria-describedby]="
              emailNotFound
                ? 'login-email-notfound'
                : showEmailValidationError
                  ? 'login-email-error'
                  : null
            "
            (input)="onEmailInput()"
          />

          <p
            *ngIf="showEmailValidationError && !emailNotFound"
            id="login-email-error"
            class="login-error-text"
            role="alert"
          >
            <ng-container *ngIf="emailControl.hasError('required')">
              Enter your email address to continue.
            </ng-container>
            <ng-container *ngIf="emailControl.hasError('email')">
              Enter a valid email address.
            </ng-container>
          </p>

          <p
            *ngIf="emailNotFound"
            id="login-email-notfound"
            class="login-error-text"
            role="alert"
          >
            We couldn't find an account with that email. Check the address and
            contact your administrator.
          </p>
        </div>

        <button
          type="submit"
          class="login-btn login-btn-primary"
          [disabled]="isLookingUp"
          [attr.aria-busy]="isLookingUp"
        >
          <span
            *ngIf="isLookingUp"
            class="login-spinner login-spinner-inline"
            aria-hidden="true"
          ></span>
          {{ isLookingUp ? 'Checking...' : 'Continue' }}
        </button>
      </form>
    </ng-container>

    <!-- ───────────── Step 2: confirm identity ───────────── -->
    <ng-container *ngIf="step === LoginStep.ConfirmIdentity">
      <h1 class="login-heading">Continue signing in</h1>
      <p class="login-subheading">Confirm your account to continue.</p>

      <div class="login-identity">
        <span class="login-identity-avatar" aria-hidden="true">
          {{ confirmedEmail.charAt(0).toUpperCase() }}
        </span>
        <span class="login-identity-email" [title]="confirmedEmail">
          {{ confirmedEmail }}
        </span>
        <button type="button" class="login-link-btn" (click)="onChangeEmail()">
          Change
        </button>
      </div>

      <!-- Lookup failed: proceed with the password path rather than blocking. -->
      <p *ngIf="lookupFailed" class="login-warning-text" role="alert">
        We couldn't check your sign-in options right now. You can still continue
        to sign in.
      </p>

      <button
        type="button"
        class="login-btn login-btn-primary"
        [disabled]="isHandingOff"
        [attr.aria-busy]="isHandingOff"
        (click)="onContinueToSignIn()"
      >
        Continue to sign in
      </button>

      <ng-container *ngIf="hasSsoOption">
        <div class="login-divider"><span>or</span></div>

        <button
          type="button"
          class="login-btn login-btn-secondary"
          [disabled]="isHandingOff"
          [attr.aria-busy]="isHandingOff"
          (click)="onContinueWithSso()"
        >
          <span
            *ngIf="preference?.provider === SsoProvider.Microsoft"
            class="login-provider-icon login-provider-icon-microsoft"
            aria-hidden="true"
          ></span>
          {{ ssoButtonLabel }}
        </button>
      </ng-container>
    </ng-container>

    <!-- Trust badge, per Figma — shown on both steps at the card bottom. -->
    <p class="login-secured">
      <span class="login-secured-icon" aria-hidden="true"></span>
      Secured by Auth0
    </p>
  </div>
</div>
